import { useState, useEffect } from "react";
import { db } from "../firebase";
import {
  collection,
  query,
  where,
  orderBy,
  onSnapshot,
} from "firebase/firestore";
import { postChatMessage } from "../services/chatService";

export default function useChat(userData) {
  const [activeChatTab, setActiveChatTab] = useState("Global");
  const [chatInput, setChatInput] = useState("");
  const [chatMessages, setChatMessages] = useState({
    System: [],
    Global: [],
    Trade: [],
    Company: [],
    Region: [],
  });

  useEffect(() => {
    if (!userData) return;

    const unsubscribers = [];

    // --- Base channels ---
    ["System", "Global", "Trade"].forEach((channel) => {
      const q = query(
        collection(db, "Chat"),
        where("chatToChannel", "==", channel),
        orderBy("chatTimestamp", "asc")
      );
      unsubscribers.push(
        onSnapshot(q, (snap) => {
          setChatMessages((prev) => ({
            ...prev,
            [channel]: snap.docs.map((doc) => ({
              id: doc.id,
              ...doc.data(),
            })),
          }));
        })
      );
    });

    // --- Company channel ---
    if (userData.userCompanyTicker && userData.userCompanyTicker !== "NONE") {
      const companyQ = query(
        collection(db, "Chat"),
        where("chatToChannel", "==", userData.userCompanyTicker),
        orderBy("chatTimestamp", "asc")
      );
      unsubscribers.push(
        onSnapshot(companyQ, (snap) => {
          setChatMessages((prev) => ({
            ...prev,
            Company: snap.docs.map((doc) => ({
              id: doc.id,
              ...doc.data(),
            })),
          }));
        })
      );
    }

    // --- Region channel ---
    if (userData.userRegion) {
      const regionQ = query(
        collection(db, "Chat"),
        where("chatToChannel", "==", userData.userRegion),
        orderBy("chatTimestamp", "asc")
      );
      unsubscribers.push(
        onSnapshot(regionQ, (snap) => {
          setChatMessages((prev) => ({
            ...prev,
            Region: snap.docs.map((doc) => ({
              id: doc.id,
              ...doc.data(),
            })),
          }));
        })
      );
    }

    return () => unsubscribers.forEach((unsub) => unsub());
  }, [userData, userData?.userCompanyTicker, userData?.userRegion]);

  const sendChatMessage = async (e) => {
    e.preventDefault();
    console.log("[sendChatMessage] Attempting to send message...");

    if (!chatInput.trim()) {
      console.warn("[sendChatMessage] Empty message, aborting.");
      return;
    }
    if (!userData) {
      console.warn("[sendChatMessage] No userData, aborting.");
      return;
    }

    const trimmedMessage = chatInput.trim();

    // ✅ Resolve correct channel
    let channelName;
    if (activeChatTab === "Company") {
      channelName = userData.userCompanyTicker || "NONE";
    } else if (activeChatTab === "Region") {
      channelName = userData.userRegion || "UNKNOWN";
    } else {
      channelName = activeChatTab;
    }

    console.log("[sendChatMessage] Resolved channelName:", channelName);

    try {
      await postChatMessage({
        uid: userData.uid,
        tab: channelName, // ✅ PASS CORRECT CHANNEL
        message: trimmedMessage,
        pip: false
      });
      console.log("[sendChatMessage] Message sent successfully!");
    } catch (error) {
      console.error("[sendChatMessage] Error sending message:", error);
    }

    setChatInput("");
  };

  return {
    activeChatTab,
    setActiveChatTab,
    chatInput,
    setChatInput,
    chatMessages,
    sendChatMessage,
  };
}
